"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseSessionHeaderMiddleware = void 0;
class UseSessionHeaderMiddleware {
    clhSessionId;
    feVersion;
    constructor(clhSessionId, feVersion) {
        this.clhSessionId = clhSessionId;
        this.feVersion = feVersion;
    }
    async pre(context) {
        const { init } = context;
        return {
            ...context,
            init: {
                ...init,
                headers: {
                    ...init.headers,
                    'x-clh-session-id': this.clhSessionId,
                    'x-clh-fe-version': this.feVersion,
                },
            },
        };
    }
}
exports.UseSessionHeaderMiddleware = UseSessionHeaderMiddleware;
//# sourceMappingURL=session-header.js.map